import { IconDefinition } from "@fortawesome/fontawesome-svg-core";

export const faInsider: IconDefinition = {
  prefix: "fak",
// @ts-ignore
  iconName: "vector",
  icon: [
    470,
    512,
    [],
    "e00f",

    "M445.8 271.7c-19-95.3-104.1-163.6-201.5-161.1c-8.8 .2-12.2-3.1-15.2-10.2c-8.8-21.1-8-43.1-7.2-65.2c.1-3.4 1.8-4.9 4.8-6.6c9.1-5.1 11.5-13.3 7.2-20.9c-3.9-7-13-9.7-19.9-6c-7.5 4-10.1 12.7-5.4 21.3c1.8 3.4 1.9 5.1-.9 7.5c-25.5 22.1-54.3 31.7-88.2 24.4c.7-1.6 1.3-2.8 1.7-4.1c2.8-9.5 0-16.8-7.6-20.2c-7-3.1-15.2-.3-18.9 6.5c-4 7.3-2 14.7 6.5 20.3c3.7 2.4 3.7 4.2 2.3 7.9c-12.3 31.1-36.2 48.5-67.2 57.9c-3.2 1-5.6 .9-8-3.2c-5.4-8.9-13.6-10.5-21.3-5.7c-6.4 4.1-8.6 13.7-4.6 20.4c4.1 7 13.1 9.3 21.1 4.6c3.2-1.9 5.4-2.9 9-1c20.2 10.9 38.3 24.3 51.7 43.4c3.6 5.2 4.1 9.2 0 15c-32.2 46.5-42.7 98.2-32.2 153.5c20.6 108.1 128 179.5 236.1 158C396.1 486.6 467.3 380 445.8 271.7zM382.6 415.9c-3.9-4.1-3.9-9.7-5.7-14.5c-12.5-33.2-34-58.8-64.7-76.2c-5.9-3.4-6.2-5.2-2.4-10.6c21.7-31.1 16.8-72.9-11.1-98.2c-27.8-25.3-70.7-26.2-98.9-2.1c-29.2 24.8-35.6 66.7-14.5 98.6c4.5 6.7 4.6 9.2-2.9 13.5c-32 18.4-53.4 45.6-64.9 80.7c-.8 2.5-1.8 5-3 8.2c-50.8-62.8-50.5-163.6 16.3-227.6c66.3-63.4 170.2-63.4 236.3 .3c66.8 64.4 66.8 165.4 15.6 227.8z"

  ]
};
